import { STEPS } from '../constants/content';

export default function Steps() {
  return (
    <section className="fm-section" id="how">
      <div className="fm-container">
        <div className="fm-sec-head">
          <p className="fm-kicker">How it works</p>
          <h2 className="fm-sec-title">How buying works</h2>
          <p className="fm-sec-lead">
            A simple path from browsing suites to downloading your software and
            starting real work.
          </p>
        </div>
        <div className="fm-step-row">
          {STEPS.map((item) => (
            <article key={item.step} className="fm-step">
              <span className="fm-step__num">{item.step}</span>
              <h3>{item.title}</h3>
              <p>{item.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
